module.exports = __webpack_public_path__ + "static/img/logo.3d1fbc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1